





























import Vue from 'vue';
import { Component, Watch, Prop } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";

const namespace: string = "assessmentForm";
@Component
export default class LiveSummaryComponent extends Vue {
    @Prop() summary: any;
    @Prop() riskLevel: any;
    @Prop() auditInfo: any;
    @Prop() completedBy: any;

    get username() {
        let userName;
        if(this.auditInfo.readOnly)
        {
          userName=this.completedBy?this.completedBy:''
        }
        else
        {
           userName=this.auditInfo.userInfo ? this.auditInfo.userInfo.userName : ""
        }
        return userName;
    }
}
